import { FormHelperText, DialogContent } from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const DialogContentStyle = styled(DialogContent)`
  padding-bottom: 24px;
`;

export const FormHelperTextStyle = styled(FormHelperText)(
  ({ theme }) => `
  color: ${theme.palette.errorDark.main};
  font-size: 16px;
  position: absolute;
  bottom: -24px;
`,
);

export const useCssClasses = makeStyles((theme: any) => ({
  input: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '250px',
    },
  },
  button: {
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '250px',
    },
  },
}));
